import React, { Component } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { withStyles } from '@material-ui/core/styles'
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import {
  Info,
  Notes,
  LocalOffer,
  History,
  Settings,
  Help,
  LibraryBooks,
  CardGiftcard,
} from '@material-ui/icons'
import ContextConsumer from './Context'

const styles = theme => ({
  root: {
    width: 244,
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
    fontWeight: 400,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
  },
  primary: {
    fontWeight: 400,
    fontSize: '0.778rem!important',
  },
})

const MenuListItemText = styled(ListItemText)`
  padding-left: 0;
`

class MenuList extends Component {
  render() {
    const { classes } = this.props

    return (
      <ContextConsumer>
        {({ data }) => {
          const hasSelectedUser = Object.keys(data.user).length > 0
          if (hasSelectedUser)
            return (
              <List component="nav" className={classes.root}>
                <ListItem button component={Link} to="">
                  <ListItemIcon>
                    <LocalOffer />
                  </ListItemIcon>
                  <MenuListItemText inset primary="Promotions" />
                </ListItem>
                <ListItem button component={Link} to="">
                  <ListItemIcon>
                    <CardGiftcard />
                  </ListItemIcon>
                  <MenuListItemText inset primary="My Freebets" />
                </ListItem>
                <ListItem button component={Link} to="">
                  <ListItemIcon>
                    <LibraryBooks />
                  </ListItemIcon>
                  <MenuListItemText inset primary="Betting History" />
                </ListItem>
                <ListItem button component={Link} to="">
                  <ListItemIcon>
                    <History />
                  </ListItemIcon>
                  <MenuListItemText inset primary="Payment History" />
                </ListItem>
                <ListItem button component={Link} to="">
                  <ListItemIcon>
                    <Settings />
                  </ListItemIcon>
                  <MenuListItemText inset primary="Settings" />
                </ListItem>
                <ListItem button component={Link} to="">
                  <ListItemIcon>
                    <Help />
                  </ListItemIcon>
                  <MenuListItemText inset primary="Help" />
                </ListItem>
              </List>
            )

          return (
            <>
              <List component="nav" className={classes.root}>
                <ListItem button component={Link} to="">
                  <ListItemIcon>
                    <LocalOffer />
                  </ListItemIcon>
                  <MenuListItemText inset primary="Promotions" />
                </ListItem>
                <ListItem button component={Link} to="">
                  <ListItemIcon>
                    <Notes />
                  </ListItemIcon>
                  <MenuListItemText inset primary="Terms & Conditions" />
                </ListItem>
                <ListItem button component={Link} to="">
                  <ListItemIcon>
                    <Info />
                  </ListItemIcon>
                  <MenuListItemText inset primary="Responsible Gambling" />
                </ListItem>
                <ListItem button component={Link} to="">
                  <ListItemIcon>
                    <Help />
                  </ListItemIcon>
                  <MenuListItemText inset primary="Help" />
                </ListItem>
              </List>
            </>
          )
        }}
      </ContextConsumer>
    )
  }
}

MenuList.propTypes = {
  classes: PropTypes.any,
}

export default withStyles(styles)(MenuList)
